import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import { DownloadSimple, UploadSimple } from '@phosphor-icons/react';
import { API } from './adminConstants';

export function CsvExportButton({ endpoint, label }) {
  const download = () => {
    const token = localStorage.getItem('token');
    if (!token) { toast.error('Please log in again'); return; }
    window.open(`${API}${endpoint}?token=${token}`, '_blank');
  };
  return <Button variant="outline" size="sm" onClick={download} data-testid={`csv-export-${label}`}><DownloadSimple size={15} className="mr-1" />{label || 'Export CSV'}</Button>;
}

export function CsvImportButton({ endpoint, label, onSuccess }) {
  const { getAuthHeader } = useAuth();
  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await axios.post(`${API}${endpoint}`, formData, { headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' } });
      toast.success(`Imported ${res.data.imported} records${res.data.skipped ? `, ${res.data.skipped} skipped (duplicates)` : ''}`);
      if (res.data.errors?.length) toast.error(`${res.data.errors.length} issues: ${res.data.errors[0]}`);
      if (onSuccess) onSuccess();
    } catch { toast.error('Import failed'); }
    e.target.value = '';
  };
  return (
    <label className="cursor-pointer">
      <Button variant="outline" size="sm" asChild><span><UploadSimple size={15} className="mr-1" />{label || 'Import CSV'}</span></Button>
      <input type="file" accept=".csv" className="hidden" onChange={handleImport} />
    </label>
  );
}
